import theme from "assets/styles/themes";
import { ChartNames } from "store/slice/charts/chartsSlice.types";
import { TUserRole } from "types/global";

export const SAVE_SEARCH = "currentSearch";
export const REDIRECT_PACE = "/pace/setup";
export const REDIRECT_LD = "/leadership-dynamics/search";
export const APP_LANG = "EN";
export const PACE_LABS_CHARTS = ["LD5", "LD7", "LD4", "LD3", "LD2", "LD8"] as ChartNames[];
export const PEERS_LIMIT = 6;
export const USERS_ADMIN_LIMIT = 5;

export const LOCATIONS = {
    INTERNATIONAL: "International",
    LOCAL: "local",
};

// Temporary list of fuctions while we wait for the API Endpoint
export const functionsList = [
    { id: 0, label: "ALL", name: "All (default)", checked: false },
    { id: 1, label: "TECHNOLOGY", name: "Technology", checked: false },
    { id: 2, label: "NON_EXECUTIVE", name: "Non-Executive", checked: false },
    { id: 3, label: "FINANCE", name: "Finance", checked: false },
    { id: 4, label: "MARKETING", name: "Marketing", checked: false },
    { id: 5, label: "LEADERSHIP", name: "Leadership", checked: false },
    { id: 6, label: "HR", name: "Human Resources", checked: false },
    { id: 7, label: "REVENUE_SALES", name: "Sales", checked: false },
    { id: 8, label: "MANAGEMENT", name: "Management", checked: false },
    { id: 9, label: "OPERATIONS", name: "Operations", checked: false },
    { id: 10, label: "NON_EXECUTIVE_LEADERSHIP", name: "Non-Executive Leadership", checked: false },
];

// Temporary list of hierarchies (PACE DAshboard filters) while we wait for the API Endpoint
export const hierarchiesList = [
    { id: 0, label: "ALL", name: "All (default)", checked: false },
    { id: 1, label: "NON-EXECUTIVE", name: "Non-Exec", checked: false },
    { id: 2, label: "CEO", name: "CEO", checked: false },
    { id: 3, label: "CXO", name: "CXO", checked: false },
    { id: 4, label: "OTHER", name: "Other", checked: false },
    { id: 5, label: "CXO-3", name: "CXO-3", checked: false },
];

// Temporary list of teams (PACE Dashboard filters) while we wait for the API Endpoint
export const teamsList = [
    { id: 1, label: "Executive Team", name: "Executive Team", count: 0, checked: false, users: [] },
    { id: 2, label: "Sales", name: "Sales", count: 0, checked: false, users: [] },
    { id: 3, label: "Finance", name: "Finance", count: 0, checked: false, users: [] },
    { id: 4, label: "Product", name: "Product", count: 0, checked: false, users: [] },
    { id: 5, label: "SLT Team", name: "SLT Team", count: 0, checked: false, users: [] },
    { id: 6, label: "Consultants Team", name: "Consultants Teams", count: 0, checked: false, users: [] },
    { id: 7, label: "R&D Group", name: "R&D Group", count: 0, checked: false, users: [] },
    { id: 8, label: "QA", name: "QA", count: 0, checked: false, users: [] },
    { id: 9, label: "Developers", name: "Developers", count: 0, checked: false, users: [] },
    { id: 10, label: "Test", name: "Test", count: 0, checked: false, users: [] },
    { id: 11, label: "Legal", name: "Leagal", count: 0, checked: false, users: [] },
];

export const mockedPeopleList = [
    { id: 0, name: "David Mango", checked: false, teams: [] },
    { id: 1, name: "Corey Herwitz", checked: false, teams: [{ name: "Sales" }] },
    { id: 2, name: "Desirae Dias", checked: false, teams: [] },
    { id: 3, name: "Justin George", checked: false, teams: [] },
    { id: 4, name: "Jaxon Gouse", checked: false, teams: [] },
    { id: 5, name: "Emery Levin", checked: false, teams: [{ name: "SLT Team" }, { name: "Product" }] },
    { id: 6, name: "Kianna Levin", checked: false, teams: [] },
    { id: 7, name: "Aspen Aminoff", checked: false, teams: [{ name: "Sales" }, { name: "Product" }] },
    { id: 8, name: "Livia Franci", checked: false, teams: [] },
    { id: 9, name: "Rayna Rosser", checked: false, teams: [] },
    { id: 10, name: "Omar Bator", checked: false, teams: [{ name: "SLT Team" }] },
    { id: 11, name: "Maren Calzoni", checked: false, teams: [{ name: "SLT Team" }] },
    { id: 12, name: "Maria Press", checked: false, teams: [] },
    { id: 13, name: "Charlie Baptista", checked: false, teams: [] },
    { id: 14, name: "Cristofer Septimus", checked: false, teams: [] },
    { id: 15, name: "Adison Culhane", checked: false, teams: [] },
    { id: 16, name: "Tiana Herwitz", checked: false, teams: [{ name: "SLT Team" }] },
    { id: 17, name: "Ahmad Korsgaard", checked: false, teams: [] },
    { id: 18, name: "Giana Saris", checked: false, teams: [{ name: "Sales" }] },
    { id: 19, name: "Livia George", checked: false, teams: [] },
    { id: 20, name: "Marley Philips", checked: false, teams: [] },
    { id: 21, name: "Corey Vaccaro", checked: false, teams: [] },
    { id: 22, name: "Charlie Aminoff", checked: false, teams: [] },
];

export const initialPagination = {
    hits: 0,
    pages: 0,
    page_size: 0,
    page_no: 0,
};

export const initialPaginationOS = {
    results_total: 0,
    page_total: 0,
    page_size: 0,
    page: 0,
};

export const allUserRoles: TUserRole[] = [
    {
        id: "placeholder",
        label: "Select Role to Add",
    },
    {
        id: "ADMIN",
        label: "Admin",
        description: "Full permissions on platform, can assign roles.",
    },
    {
        id: "VIEW_EDIT",
        label: "View & Edit",
        description: "Can view/edit/create content.",
    },
    {
        id: "VIEW_ONLY",
        label: "View Only",
        description: "Can only view the platform.",
    },
    {
        id: "PROFILE",
        label: "Profile Only",
        description: "No access to product, only you can see their profile.",
    },
];

export const functionsPillColor = {
    technology: theme.palette.others.limeGreen,
    non_exec: theme.palette.others.goldenYellow,
    finance: theme.palette.others.brightOrange,
    marketing: theme.palette.others.neonSkyBlue,
    leadership: theme.palette.others.darkGrey,
    hr: theme.palette.others.darkOrange,
    revenue: theme.palette.others.skyBlue,
    management: theme.palette.others.lavenderPurple,
    operations: theme.palette.others.brightPink,
    non_exec_leadership: theme.palette.others.warmBeige,
    other: theme.palette.others.midDarkGrey,
};
